export class ServerError {
  message: string;
  status: number;
}
